import { URL_CREATE_CONTACT } from 'constants/urls';

const createContact = async (contact) => {
	const options = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		body: JSON.stringify({ payload: contact }),
	};
	const res = await fetch(URL_CREATE_CONTACT, options);
	const data = await res.json();

	return data;
};

export default createContact;
